import { useTranslation } from 'react-i18next';
import { Alert } from '@/common/components/Alert/Alert';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { BudgetIcon } from '@/common/components/BudgetIcon/BudgetIcon';
import { Heading } from '@/common/components/Heading/Heading';
import { Modal } from '@/common/components/Modal/Modal';
import { Stack } from '@/common/components/Stack/Stack';
import { IEmployeeBudget } from '@/common/integrations/menhir/employee/budgets/budgets.types';
import { getBudgetReimbursementKey } from '@/common/utils/budgets';

export type TBudgetLearningCenterProps = {
  employeeBudget: IEmployeeBudget;
  onClose: () => void;
};

export function BudgetLearningCenter({
  employeeBudget,
  onClose,
}: TBudgetLearningCenterProps) {
  const { t } = useTranslation();
  return (
    <Modal
      title={employeeBudget.budget.name}
      icon={<BudgetIcon type={employeeBudget.budget.logo} />}
      iconBadgeColor="accentSecondary20"
      onClose={onClose}
      size="md"
    >
      <Stack gap="lg">
        <Heading level={4}>
          {t('dashboard.budgets.details.learning_centre.about')}
        </Heading>
        <BodyText className="whitespace-pre-line">
          {employeeBudget.budget.description}
        </BodyText>
        <Heading level={4}>
          {t('dashboard.budgets.details.learning_centre.reimbursement')}
        </Heading>
        <BodyText className="whitespace-pre-line">
          {t(getBudgetReimbursementKey(employeeBudget.budget))}
        </BodyText>
        {employeeBudget.budget.reimbursementRequiredFiles && (
          <Alert type="info">
            {employeeBudget.budget.reimbursementRequiredFiles}
          </Alert>
        )}
      </Stack>
    </Modal>
  );
}
